import { render, staticRenderFns } from "./FooterSocials.vue?vue&type=template&id=1b8beaa8&"
import script from "./FooterSocials.vue?vue&type=script&lang=js&"
export * from "./FooterSocials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SocialsRoundedComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SocialsRoundedComponent/index.vue').default,FooterFeedback: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Footer/FooterFeedback.vue').default})
